import {
    Component,
    ViewEncapsulation,
    Output,
    ElementRef,
    Input,
    AfterViewInit,
    ViewChild,
    OnInit,
    OnDestroy,
    EventEmitter
} from '@angular/core';
import {
    proj,
    geom,
    format,
    extent
} from 'openlayers';
import {
    Subject
} from 'rxjs';
import {
    ConfigurationKeyEnum
} from '../../dataModels/data-models';
import {
    AppConfigService
} from '../../../shared/services/app-config.service';
import {
    AltairLayerService
} from '../../../shared/services/altairLayer.service';


declare var ol: any;
declare var google: any;

@Component( {
    moduleId: module.id,
    selector: 'map-component',
    templateUrl: 'map-component.component.html',
    styleUrls: [ '../../../assets/css/map.css', '../../../assets/css/map_rtl.scss' ],
    encapsulation: ViewEncapsulation.None,
} )

export class MapComponent implements AfterViewInit, OnInit, OnDestroy {

    //#region  View Child
    @ViewChild( "mapElement" ) mapElement: ElementRef;
    @ViewChild( "search" ) searchElement: ElementRef;
    @ViewChild( "mouseLatlon" ) mouseLatlonElement: ElementRef;
    @ViewChild( "mousedegree" ) mousedegreeElement: ElementRef;
    //@ViewChild("RadiusEle") RadiusElement: ElementRef;
    //#endregion

    //#region  Map Attributes  
    @Input() mapId: string = "map";
    @Input() PopupmapId: string = "Popupmap";
    @Input() zoomLevel: number = 1;
    @Input() mapType: string = 'google';
    @Input() mapUrl: string = 'http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}';
    @Input() minZoom: number = 2;
    @Input() maxZoom: number = 25;
    @Input() centerLat: number = 30;
    @Input() centerLng: number = 30;
    @Input() focusLat: number = 30;
    @Input() focusLng: number = 30;
    @Input() centerRadiusGeo: any;
    @Input() radius: number;
    //#endregion

    //#region  Map Featues 
    @Input() showTraffic: boolean = false;
    @Input() showHybird: boolean = false;
    @Input() enableFeatureClick: boolean = false;
    @Input() enableOverlayClick: boolean = false;
    @Input() showXYLabel: boolean = true;
    @Input() showSatelite: boolean = false;
    @Input() showZoom: boolean = true;
    @Input() showAltairLayers: boolean = false;
    @Input() showGeoCode: boolean = true;
    @Input() AllowClusting: boolean = true;
    @Input() ShowSettingMenu: boolean = true;
    @Input() mapWidth: number;
    @Input() shapeTypes = [];

    @Input() showSensors: boolean = false;
    @Input() showVehicleCodeLabel: boolean = true;
    @Input() showVehiclePlateNumberLabel: boolean = true;

    //output as event emmiter 
    @Output() toggleShowSensors: EventEmitter < boolean > = new EventEmitter();
    @Output() toggleShowVehicleCodeLabel: EventEmitter < boolean > = new EventEmitter();
    @Output() toggleShowVehiclePlateNumberLabel: EventEmitter < boolean > = new EventEmitter();
    @Output() onLocationsDetected: EventEmitter < any > = new EventEmitter < any > ();

    //#endregion

    //#region Private Members
    private map: any;
    private popup: any;
    private select: any;
    private base_layer: any;
    private base_source: any;
    private vectorSource;
    private vectorLayer;
    private clusterSource;
    private clusterLayer;
    private satelliteLayer;
    private openCycleMapLayer;
    private ZoomControl;
    private toggleActive: boolean = false;
    private atairLayersToggleActive: boolean = false;
    private layers: any[] = [];
    private iconlayers: any[] = [];
    private geofencesOnLayer: any[] = [];
    private geoStyle: any = {};
    private displayGeo: boolean = false;
    private clickedGeo: any = {};
    private draw: any;
    private wktFormat: format.WKT = new format.WKT();
    private drawingGraphicsLayer: any;
    private selectedfeature: any = null;
    private drawingGraphicSource: any;
    private poiLayerSelected: boolean = false;
    private branchLayerSelected: boolean = false;
    private geofenceLayerSelected: boolean = false;

    public MarkertransformedLong: number = 0;
    public MarkertransformedLat: number = 0;
    //#endregion

    //#region public Subject
    public Change$: Subject < any > = new Subject();
    public ZOOMChange$: Subject < any > = new Subject();
    public Click$: Subject < any > = new Subject();
    public Load$: Subject < any > = new Subject();
    public DrawEnd$: Subject < any > = new Subject();
    public DeleteDraw$: Subject < any > = new Subject();
    public EditDraw$: Subject < any > = new Subject();
    public FeatureClicked$: Subject < any > = new Subject();
    public OverlayClicked$: Subject < any > = new Subject();
    //#endregion

    //#region public Members
    public showDraw: boolean = false;
    //#endregion

    //#region interface
    constructor( private _appConfigService: AppConfigService, private _altairLayerService: AltairLayerService ) {
        var result = this._appConfigService.getSubscriberConfiguration().then( result => {
            if (result) {
                console.log("getSubscriberConfiguration result", result)
                var long = result.Configurations.find( ( x ) => x.Key == ConfigurationKeyEnum.DefaultLongitude.toString() );
                this.centerLng = long ? parseFloat( long.Value ) : null;

                var lat = result.Configurations.find( ( x ) => x.Key == ConfigurationKeyEnum.DefaultLatitude.toString() );
                this.centerLat = lat ? parseFloat( lat.Value ) : null;

                var zoomResult = result.Configurations.find( ( x ) => x.Key == ConfigurationKeyEnum.DefaultZoom.toString() );
                this.zoomLevel = zoomResult ? parseInt( zoomResult.Value ) : null;

                var MapUrlResult = result.Configurations.find( ( x ) => x.Key == ConfigurationKeyEnum.MapUrl.toString() );
                this.mapUrl = MapUrlResult ? MapUrlResult.Value : null;
                var mapTypeResult = result.Configurations.find( ( x ) => x.Key == ConfigurationKeyEnum.MapProvider.toString() )
                this.mapType = mapTypeResult ? mapTypeResult.Value : null;

                var minZoomResult = result.Configurations.find( ( x ) => x.Key == ConfigurationKeyEnum.MinZoomLevel.toString() );
                this.minZoom = minZoomResult ? parseInt( minZoomResult.Value ) : null;

                var maxZoomResult = result.Configurations.find( ( x ) => x.Key == ConfigurationKeyEnum.MaxZoomLevel.toString() );
                this.maxZoom = maxZoomResult ? parseInt( maxZoomResult.Value ) : null;
            }

            this.SetMapDefualtAttributes( this.centerLng, this.centerLat, this.zoomLevel, this.mapType, this.mapUrl, this.minZoom, this.maxZoom );
            this.CreateMap();


            if ( this.ShowSettingMenu ) {
                this.AddSettingicon()
            }

            if ( this.showGeoCode ) {

                this.addGeoCoderControl();
            }

            if ( this.showAltairLayers ) {
                this.addAltairLayers();
            }

        } );

    }

    ngOnInit() {

    }

    ngAfterViewInit(): void {

    }

    ngOnDestroy(): void {
        this.Change$.unsubscribe();
        this.ZOOMChange$.unsubscribe();
        this.Click$.unsubscribe();
        this.Load$.unsubscribe();
        this.DrawEnd$.unsubscribe();
        this.EditDraw$.unsubscribe();
        this.DeleteDraw$.unsubscribe();
        this.FeatureClicked$.unsubscribe();
    }
    //#endregion

    //#region Private Methods
    private SetMapDefualtAttributes( _centerLong, _centerLat, _zoom, _baseMapType, _mapUrl, _minZoom, _maxZoom ): void {
        this.centerLng = _centerLong ? _centerLong : 30;
        this.centerLat = _centerLat ? _centerLat : 30;
        this.mapType = _baseMapType ? _baseMapType : 'google';
        this.zoomLevel = _zoom ? _zoom : 10;
        this.minZoom = _minZoom ? _minZoom : 0;
        this.maxZoom = _maxZoom ? _maxZoom : 25;
        this.mapUrl = _mapUrl ? _mapUrl : 'http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}';
        // to add api key 
        //this.mapUrl = _mapUrl ? _mapUrl : 'http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}' + "&key=" + "AIzaSyAAWPYbQpoNYv_BgSCknDfi-i-d1lznt8U";
    }

    private CreateMap(): void {

        var self = this;

        switch ( this.mapType ) {
            case "esri": {
                this.base_source = new ol.source.XYZ( {
                    url: this.mapUrl
                } );

                break;
            }
            case "google": {
                this.base_source = new ol.source.XYZ( {
                    url: this.mapUrl
                } );
                break;
            }
            default: {
                this.base_source = new ol.source.OSM();
                break;
            }


        }
        this.base_layer = new ol.layer.Tile( {
            source: this.base_source

        } );
        this.vectorSource = new ol.source.Vector( {

        } );
        this.vectorLayer = new ol.layer.Vector( {
            source: this.vectorSource,
        } );
        this.vectorLayer.setZIndex( 999 );
        this.drawingGraphicSource = new ol.source.Vector( {

        } );
        this.drawingGraphicsLayer = new ol.layer.Vector( {
            source: this.drawingGraphicSource,
        } );
        this.map = new ol.Map( {
            layers: [ this.base_layer, this.vectorLayer, this.drawingGraphicsLayer ],
            controls: [],
            view: new ol.View( {
                center: ol.proj.transform( [ self.centerLat, self.centerLng ], 'EPSG:4326', 'EPSG:3857' ),
                zoom: self.zoomLevel,
                minZoom: self.minZoom,
                maxZoom: self.maxZoom
            } )
        } );
        this.setcenterMap( this.centerLng, this.centerLat );
        if ( this.AllowClusting ) {
            this.AddClusting();
        }
        if ( this.showSatelite ) {
            this.AddSatelliteLayer()
        }
        if ( this.showZoom ) {
            this.AddZoom();
        }
        if ( this.showXYLabel ) {
            this.AddXYlabel();
        }
        if ( this.showTraffic ) {
            this.AddTraffic();
        }
        if ( this.showHybird ) {
            this.AddHybird();
        }

        this.mapElement.nativeElement.id = this.mapId;
        self.map.setTarget( this.mapElement.nativeElement.id );
        // var element = self.PopupElement;
        self.Load$.next( true );
        self.map.on( "click", function ( e ) {
            // if circle
            // self.centerRadiusGeo = ol.proj.transform(e.coordinate, 'EPSG:3857', 'EPSG:4326');
            self.Click$.next( e );
            if ( self.enableFeatureClick ) {
                self.map.forEachFeatureAtPixel( e.pixel, function ( feature, layer ) {
                    if ( self.showAltairLayers && feature.getId().toString().includes( "g" ) ) {
                        let geofenceId: number = +feature.getId().toString().replace( "g", "" );

                        if ( Number.isNaN( geofenceId ) ) {
                            geofenceId = +feature.getId().toString().replace( "alatirlayergeofence_", "" );
                        }
                        self.displayGeo = true;
                        self.geoStyle = {
                            left: e.pixel[ 0 ] + 'px',
                            top: ( e.pixel[ 1 ] - 15 ) + 'px'
                        };
                        self.clickedGeo = self.geofencesOnLayer.find( g => g.Id == geofenceId );

                    }

                    if ( feature.getId() && feature.getId().toString().indexOf( "alatirlayer" ) < 0 ) {
                        self.FeatureClicked$.next( feature.getId() );
                    }

                } );
            }
        } );


        self.map.on( "moveend", function ( e ) {
            self.Change$.next( e );
            if ( self.showAltairLayers ) {
                self.changeAlatirLayerextend();
            }
        } );

        self.map.on( "zoomend", function ( e ) {
            self.ZOOMChange$.next( e );
            if ( self.showAltairLayers ) {
                self.changeAlatirLayerextend();
            }
        } );
    }
    private updateGeoDisplay( status ) {
        // console.log("updateGeoDisplay");
        // console.log(status);
        this.displayGeo = status;
    }

    private AddClusting() {
        this.clusterSource = new ol.source.Cluster( {
            distance: 100,
            source: this.vectorSource
        } );
        this.clusterLayer = new ol.layer.Vector( {
            source: this.clusterSource
        } );
        this.map.addLayer( this.clusterLayer );
    }

    private AddSatelliteLayer() {
        if ( this.mapType == "google" )
            this.satelliteLayer = new ol.layer.Tile( {
                source: new ol.source.XYZ( {
                    url: "http://mt0.google.com/vt/hl=en&x={x}&y={y}&z={z}&s=Ga&lyrs=y"
                } )

            } );
        else if ( this.mapType == "esri" ) {
            this.satelliteLayer = new ol.layer.Tile( {
                source: new ol.source.XYZ( {
                    url: "https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                } )

            } );
        }
        this.satelliteLayer.setZIndex( 2 );
        this.map.addLayer( this.satelliteLayer );
    }

    private RemoveSatelliteLayer() {

        this.map.removeLayer( this.satelliteLayer );
    }

    private AddTraffic() {
        if ( this.mapType == "google" ) {
            this.base_layer.setSource( new ol.source.XYZ( {
                url: "https://mts0.google.com/vt?hl=en&src=app&x={x}&y={y}&z={z}&s=&lyrs=m@221000000,traffic%7Cseconds_into_week:-1&style=XXX"
            } ) );
            this.base_layer.changed();
            if ( this.showSatelite ) {
                this.satelliteLayer.setSource( new ol.source.XYZ( {
                    url: "http://mt0.google.com/vt/hl=en&x={x}&y={y}&z={z}&s=Ga&lyrs=y,traffic%7Cseconds_into_week:-1&style=XXX"
                } ) );
                this.satelliteLayer.changed();
            }
        }
    }

    private RemoveTraffic() {
        if ( this.mapType == "google" ) {
            this.base_layer.setSource( new ol.source.XYZ( {
                url: "http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
            } ) );
            this.base_layer.changed();
            if ( this.showSatelite ) {
                this.satelliteLayer.setSource( new ol.source.XYZ( {
                    url: "http://mt0.google.com/vt/hl=en&x={x}&y={y}&z={z}&s=Ga&lyrs=y"
                } ) );
                this.satelliteLayer.changed();
            }
        }
    }

    private AddHybird() {
        if ( this.mapType == "google" ) {
            this.base_layer.setSource( new ol.source.XYZ( {
                url: "https://mts0.google.com/vt?hl=en&src=app&x={x}&y={y}&z={z}&s=&lyrs=m@221000000,traffic%7Cseconds_into_week:-1&style=XXX"
            } ) );
            this.base_layer.changed();

            this.satelliteLayer = new ol.layer.Tile( {
                source: new ol.source.XYZ( {
                    url: "http://mt0.google.com/vt/hl=en&x={x}&y={y}&z={z}&s=Ga&lyrs=y,traffic%7Cseconds_into_week:-1&style=XXX"
                } )

            } );

            this.satelliteLayer.setZIndex( 2 );
            this.map.addLayer( this.satelliteLayer );

        }
    }

    private RemoveHybird() {
        if ( this.mapType == "google" ) {
            this.base_layer.setSource( new ol.source.XYZ( {
                url: "http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
            } ) );
            this.base_layer.changed();
            this.map.removeLayer( this.satelliteLayer );
        }
    }

    private AddXYlabel() {

        this.map.on( 'pointermove', ev => this.getCoordinates( ev, this ) );
    }

    private getCoordinates( evt, self ) {

        var lonlat = ol.proj.transform( evt.coordinate, 'EPSG:3857', 'EPSG:4326' );
        var lon = lonlat[ 0 ];
        var lat = lonlat[ 1 ]
        if ( self.mouseLatlonElement && self.mouseLatlonElement.nativeElement ) {
            self.mouseLatlonElement.nativeElement.innerText = lat + ' , ' + lon;
            self.mouseLatlonElement.nativeElement.style.display = 'inline-block';
        }

        if ( self.mousedegreeElement && self.mousedegreeElement.nativeElement ) {
            self.mousedegreeElement.nativeElement.innerText = this.convertDMS( lat, lon );
            self.mousedegreeElement.nativeElement.style.display = 'inline-block';
        }

    }

    private toDegreesMinutesAndSeconds( coordinate ) {
        var absolute = Math.abs( coordinate );
        var degrees = Math.floor( absolute );
        var minutesNotTruncated = ( absolute - degrees ) * 60;
        var minutes = Math.floor( minutesNotTruncated );
        var seconds = Math.floor( ( minutesNotTruncated - minutes ) * 60 );

        return degrees + " " + minutes + " " + seconds;
    }

    private convertDMS( lat, lng ) {
        var latitude = this.toDegreesMinutesAndSeconds( lat );
        var latitudeCardinal = Math.sign( lat ) >= 0 ? "N" : "S";

        var longitude = this.toDegreesMinutesAndSeconds( lng );
        var longitudeCardinal = Math.sign( lng ) >= 0 ? "E" : "W";

        return latitude + " " + latitudeCardinal + " , " + longitude + " " + longitudeCardinal;
    }

    private AddZoom() {
        this.ZoomControl = new ol.control.Zoom();
        this.map.addControl( this.ZoomControl );
    }

    private RemoveZoom() {
        this.map.removeControl( this.ZoomControl );
    }

    private AddCycleLayer() {

        this.openCycleMapLayer = new ol.layer.Tile( {
            source: new ol.source.OSM( {
                attributions: [
                    'All maps © <a href="http://www.openseamap.org/">OpenSeaMap</a>',
                ],
                opaque: false,
                url: 'https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png'
            } )
        } );

        this.map.addLayer( this.satelliteLayer );
    }

    private RemoveCycleLayer() {
        this.map.removeLayer( this.openCycleMapLayer );
    }

    private AddTransportLayer() {

    }

    private RemoveTransportLayer() {

    }

    private AddHumanitarianLayer() {

    }

    private RemoveHumanitariaLayern() {

    }

    private AddSettingicon() {

        this.layers.push( {
            DisplayName: "XY Label",
            checked: this.showXYLabel,
            disabled: false
        } );
        this.layers.push( {
            DisplayName: "Zoom",
            checked: this.showZoom,
            disabled: false
        } );
        this.layers.push( {
            DisplayName: "Search",
            checked: this.showGeoCode,
            disabled: false
        } );



        if ( this.mapType == "google" )
            this.layers.push( {
                DisplayName: "Traffic",
                checked: this.showTraffic,
                disabled: false
            } );
        else
            this.layers.push( {
                DisplayName: "Traffic",
                checked: this.showTraffic,
                disabled: true
            } );

        if ( this.mapType == "osm" )
            this.layers.push( {
                DisplayName: "Satellite",
                checked: this.showSatelite,
                disabled: true
            } );
        else
            this.layers.push( {
                DisplayName: "Satellite",
                checked: this.showSatelite,
                disabled: false
            } );

        if ( this.mapType == "google" )
            this.layers.push( {
                DisplayName: "Hybird",
                checked: this.showHybird,
                disabled: false
            } );
        else
            this.layers.push( {
                DisplayName: "Hybird",
                checked: this.showHybird,
                disabled: true
            } );

        if ( this.mapType == "osm" ) {
            this.layers.push( {
                DisplayName: "Cycle",
                checked: this.showSatelite,
                disabled: false
            } );
            this.layers.push( {
                DisplayName: "Transport",
                checked: this.showSatelite,
                disabled: false
            } );
            this.layers.push( {
                DisplayName: "Humanitarian",
                checked: this.showSatelite,
                disabled: false
            } );
        }
        //this.layers.push({ DisplayName: "Icons", checked: false, disabled: false, title: true });
        //this.layers.push({ DisplayName: "Vehicle Code Label", checked: this.showVehicleCodeLabel, disabled: false });
        //this.layers.push({ DisplayName: "Vehicle Plate Number Label", checked: this.showVehiclePlateNumberLabel, disabled: false });
        //this.layers.push({ DisplayName: "Sensors", checked: this.showSensors, disabled: false });

    }

    private addGeoCoderControl() {
        if ( this.searchElement ) {
            var input = this.searchElement.nativeElement;
            if ( input ) {
                var autocomplete = new google.maps.places.Autocomplete( input );
                autocomplete.addListener( 'place_changed', () => {
                    var place = autocomplete.getPlace();
                    if ( !place.geometry )
                        return;
                    this.setcenterMap( place.geometry.location.lng(), place.geometry.location.lat(), 16 );
                } );
            }
        }
    }

    private onToggle( layer ) {
        switch ( layer.DisplayName ) {
            case "XY Label": {
                if ( layer.checked ) {
                    this.showXYLabel = true;
                } else {
                    this.showXYLabel = false;
                }
                break;
            }
            case "Traffic": {
                if ( layer.checked ) {
                    this.AddTraffic();
                    this.showTraffic = true;
                } else {
                    this.RemoveTraffic();
                    this.showTraffic = false;
                }
                break;
            }

            case "Hybird": {
                if ( layer.checked ) {
                    this.AddHybird();
                    this.showHybird = true;
                } else {
                    this.RemoveHybird();
                    this.showHybird = false;
                }
                break;
            }
            case "Zoom": {
                if ( layer.checked ) {
                    this.AddZoom();
                    this.showZoom = true;
                } else {
                    this.RemoveZoom();
                    this.showZoom = false;
                }
                break;
            }
            case "Satellite": {
                if ( layer.checked ) {
                    this.AddSatelliteLayer();
                    this.showSatelite = true;

                } else {
                    this.RemoveSatelliteLayer();
                    this.showSatelite = false;

                }
                break;
            }
            case "Cycle": {
                if ( layer.checked ) {
                    this.AddCycleLayer();

                } else {
                    this.RemoveCycleLayer();

                }
                break;
            }
            case "Transport": {
                if ( layer.checked ) {


                } else {


                }
                break;
            }
            case "Humanitarian": {
                if ( layer.checked ) {

                } else {


                }
                break;
            }
            case "Search": {
                if ( layer.checked ) {
                    this.showGeoCode = true;
                    setTimeout( () => {
                        this.addGeoCoderControl();
                    }, 50 );
                } else {
                    this.showGeoCode = false;
                }
                break;
            }
        }

    }

    private getShapeStyle( shapeType ) {
        if ( shapeType == 'Circle' ) {
            return 'fa fa-circle-thin';
        } else if ( shapeType == 'Polygon' ) {
            return 'icon icon-polygon';
        } else if ( shapeType == 'LineString' ) {
            return 'fa fa-vine';
        } else if ( shapeType == 'Point' ) {
            return 'fa fa-circle';
        }

    }

    private SetCenterOfExtent( Extent ) {
        var X = Extent[ 0 ] + ( Extent[ 2 ] - Extent[ 0 ] ) / 2;
        var Y = Extent[ 1 ] + ( Extent[ 3 ] - Extent[ 1 ] ) / 2;
        this.map.getView().setCenter( ol.proj.transform( [ X, Y ], "EPSG:4326", "EPSG:3857" ) );


    }
    //#endregion

    //#region public Methods
    public setcenterMap( long, lat, zoom = null ) {
        //console.log("setcenterMap");
        //console.log("long", long);
        //console.log("lat", lat);
        if ( zoom )
            this.map.getView().setZoom( zoom );
        this.map.getView().setCenter( ol.proj.fromLonLat( [ long, lat ], 'EPSG:3857' ) );

    }

    public getCenter() {

        return ol.proj.transform( this.map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326' );

    }

    public getZoom() {
        return this.map.getView().getZoom();
    }

    public GetMapAddress( lat: number, lng: number ): any {
        let geocoder = new google.maps.Geocoder();
        let latlng = new google.maps.LatLng( lat, lng );
        let request = {
            latLng: latlng
        };
        return new Promise( ( resolve, reject ) => {
            geocoder.geocode( request, ( results, status ) => {
                if ( status == google.maps.GeocoderStatus.OK ) {
                    if ( results[ 0 ] != null ) {
                        resolve( results[ 0 ].formatted_address );
                    }
                } else resolve( null );

            } );
        } );
    }

    public GetMapExtent() {
        return this.map.getView().calculateExtent( this.map.getSize() );
    }

    public SetMapExtent( location: any[] ) {
        var ext = ol.extent.boundingExtent( location );
        ext = ol.proj.transformExtent( ext, ol.proj.get( 'EPSG:4326' ), ol.proj.get( 'EPSG:3857' ) );
        this.map.getView().fit( ext, this.map.getSize() );
    }
    // Add feature on defualt source 
    public AddFeature( lat, lng, text = "", id, icon = "", color ? , rotate ? , zIndex ? , offsetY ? , offset ? ) {

        var feature = this.vectorSource.getFeatureById( id );
        if ( !feature ) {
            var iconFeature = new ol.Feature( {
                geometry: new
                ol.geom.Point( ol.proj.fromLonLat( [ lng, lat ] ) ),
                name: ( text != null ? text : "" ),
                id: id,
            } );
            iconFeature.setId( id );
            if ( offset && offset != null ) {
                iconFeature.getGeometry().translate( offsetY, offsetY );
            }
            if ( icon ) {

                iconFeature.setStyle( new ol.style.Style( {
                    image: new ol.style.Icon( {
                        color: color ? color : '#fff',
                        crossOrigin: 'anonymous',
                        src: icon,
                        rotation: rotate ? rotate : 0,
                        //offset: offset ? [offset, offset] :[0,0],
                        //offsetY: offset ? offset : '0',
                        //offsetX: offset ? offset : '0',
                    } ),
                    text: new ol.style.Text( {
                        font: '12px Calibri,sans-serif',
                        fill: new ol.style.Fill( {
                            color: '#fff'
                        } ),
                        stroke: new ol.style.Stroke( {
                            color: '#666666',
                            width: 4
                        } ),
                        text: ( text != null ? text : "" ),
                        offsetY: offsetY ? offsetY : '40',
                    } ),
                    zIndex: zIndex ? zIndex : 100
                } ) );
            }

            this.vectorSource.addFeature( iconFeature );
            this.vectorSource.refresh();
            if ( this.AllowClusting ) {
                this.clusterSource.addFeature( iconFeature );
                this.clusterSource.refresh();
            }
        }
    }

    public AddFeaturewithLayer( Layer, lat, lng, text = "", id, icon = "", color ? , rotate ? , zIndex ? , offsetY ? , offset ? ) {
        var self = this;
        var layer = null;
        var source;

        this.map.getLayers().forEach( function ( lyr ) {

            if ( Layer == lyr.Name ) {
                layer = lyr;
            }

        } );
        if ( layer == null ) {
            layer = self.createGraphicLayerWithId( Layer, Layer );

        }
        source = layer.getSource();
        var feature = source.getFeatureById( id );
        if ( !feature ) {
            var iconFeature = new ol.Feature( {
                geometry: new
                ol.geom.Point( ol.proj.fromLonLat( [ lng, lat ] ) ),
                name: ( text != null ? text : "" ),
                id: id,
            } );
            iconFeature.setId( id );
            if ( offset && offset != null ) {
                iconFeature.getGeometry().translate( offsetY, offsetY );
            }
            if ( icon ) {
                iconFeature.setStyle( new ol.style.Style( {
                    image: new ol.style.Icon( {
                        color: color ? color : '#fff',
                        crossOrigin: 'anonymous',
                        src: icon,
                        rotation: rotate ? rotate : 0,
                        //offset: offset ? [offset, offset] :[0,0],
                        //offsetY: offset ? offset : '0',
                        //offsetX: offset ? offset : '0',
                    } ),
                    text: new ol.style.Text( {
                        font: '12px Calibri,sans-serif',
                        fill: new ol.style.Fill( {
                            color: '#fff'
                        } ),
                        stroke: new ol.style.Stroke( {
                            color: '#666666',
                            width: 4
                        } ),
                        text: ( text != null ? text : "" ),
                        offsetY: offsetY ? offsetY : '40',
                    } ),
                    zIndex: zIndex ? zIndex : 100
                } ) );
            }

            source.addFeature( iconFeature );
            source.refresh();
            if ( this.AllowClusting ) {
                this.clusterSource.addFeature( iconFeature );
                this.clusterSource.refresh();
            }
            //if (this.showSatelite) {
            //    this.satelliteLayer.addFeature(iconFeature);
            //    this.satelliteLayer.refresh();
            //}


        }
    }

    public HideshowLayers( Layer ) {
        this.map.getLayers().forEach( function ( lyr ) {
            if ( Layer == lyr.id ) {
                lyr.setVisible( !lyr.getVisible() );
            }
        } );
    }

    public RemoveFeature( id ) {

        var feature = this.vectorSource.getFeatureById( id );
        if ( feature ) {

            this.vectorSource.removeFeature( feature );
            this.vectorSource.refresh();
        }
        if ( this.AllowClusting ) {
            var feature = this.clusterSource.getFeatureById( id );
            if ( feature ) {

                this.clusterSource.removeFeature( feature );
                this.clusterSource.refresh();
            }
        }

    }

    public RemoveAllFeatures() {
        this.vectorSource.clear();
        this.vectorSource.refresh();
        if ( this.AllowClusting ) {
            this.clusterSource.clear();
            this.clusterSource.refresh();
        }
        this.drawingGraphicSource.clear();
        this.drawingGraphicSource.refresh();

    }

    public modifyFeature( lat, lng, text = "", id, icon = "" ) {
        var iconFeature = this.vectorSource.getFeatureById( id );
        if ( iconFeature ) {
            var pos = ol.proj.fromLonLat( [ lng, lat ] );
            iconFeature.getGeometry().setCoordinates( pos );
            iconFeature.set( 'MapMarkerTitle', "item." );
            this.vectorSource.refresh();
        }
        if ( this.AllowClusting ) {
            var iconFeature = this.clusterSource.getFeatureById( id );
            if ( iconFeature ) {
                var pos = ol.proj.fromLonLat( [ lng, lat ] );
                iconFeature.getGeometry().setCoordinates( pos );
                iconFeature.set( 'MapMarkerTitle', "item." );
                this.clusterSource.refresh();
            }
        }
    }

    public AddormodifyFeature( lat, lng, text = "", id, icon = "", color ? ) {
        //console.log( "AddormodifyFeature" );

        var iconFeature = this.vectorSource.getFeatureById( id );
        if ( iconFeature ) {
            var pos = ol.proj.fromLonLat( [ lng, lat ] );
            iconFeature.getGeometry().setCoordinates( pos );
            iconFeature.set( 'MapMarkerTitle', "item." );
            this.vectorSource.refresh();
            if ( this.AllowClusting ) {
                var iconFeature = this.clusterSource.getFeatureById( id );
                if ( iconFeature ) {
                    var pos = ol.proj.fromLonLat( [ lng, lat ] );
                    iconFeature.getGeometry().setCoordinates( pos );
                    iconFeature.set( 'MapMarkerTitle', "item." );
                    this.clusterSource.refresh();
                }
            }

        } else {
            this.AddFeature( lat, lng, text, id, icon, color );
        }
    }

    public updateSize() {
        if ( this.map )
            this.map.updateSize();
    }

    public getevtcoordinates( evt ): any {
        let coo = this.map.getEventCoordinate( evt );
        return ol.proj.transform( coo, 'EPSG:3857', 'EPSG:4326' );

    }

    public addInteraction( Interaction ) {
        var self = this;
        if ( Interaction !== 'None' ) {
            this.drawingGraphicSource.clear();
            let draw = new ol.interaction.Draw( {
                source: this.drawingGraphicSource,
                type: Interaction
            } );
            draw.setActive( true );

            draw.on( "drawend", ( evt ) => {

                var geometryMeasure = 0;
                var radius = 0;
                var geofenceType = Interaction;
                var geometry = evt.feature.getGeometry();
                let centerCircle = [];
                if ( geofenceType == 'Circle' ) {
                    radius = geometry.getRadius().toFixed( 2 );
                    geometry = geom.Polygon.fromCircle( geometry, 50 );
                    geometryMeasure = Math.pow( radius, 2 ) * Math.PI;
                    centerCircle = ol.proj.transform( ol.extent.getCenter( geometry.getExtent() ), 'EPSG:3857', 'EPSG:4326' );
                } else if ( geofenceType == 'Polygon' )
                    geometryMeasure = geometry.getArea();
                else
                    geometryMeasure = geometry.getLength();

                var newObject = jQuery.extend( true, {}, geometry );

                var newObject = newObject.transform( "EPSG:3857", "EPSG:4326" );
                var wktGeometry = self.wktFormat.writeGeometry( newObject );
                self.DrawEnd$.next( {
                    type: geofenceType,
                    measure: geometryMeasure.toFixed( 3 ),
                    geometryObject: wktGeometry,
                    center: centerCircle,
                    radius: radius
                } );
                self.map.removeInteraction( draw );

            } );
            this.map.addInteraction( draw );
        }
    }

    public removeInteraction( Interaction ) {
        this.map.removeInteraction( Interaction );
    }

    public deletedraw( id, frommap ) {
        var feature = this.drawingGraphicSource.getFeatureById( id );
        if ( feature ) {
            this.drawingGraphicSource.removeFeature( feature );
            this.drawingGraphicSource.refresh();
            this.selectedfeature = null;
        }
        if ( frommap )
            this.DeleteDraw$.next( id );
    }

    public adddrawOnMap( id, geometryString ) {
        var feature = this.drawingGraphicSource.getFeatureById( id );
        if ( !feature ) {
            let geofenceFeature = this.wktFormat.readFeature( geometryString );
            var geometry = geofenceFeature.getGeometry().transform( "EPSG:4326", "EPSG:3857" );
            geofenceFeature.setGeometry( geometry );
            geofenceFeature.setId( id );
            this.drawingGraphicSource.addFeature( geofenceFeature );
            this.drawingGraphicSource.refresh();

        }
    }

    public adddrawOnLayer( layerId, id, geometryString ) {
        var self = this;
        var layer = null;
        var source;
        this.map.getLayers().forEach( function ( lyr ) {

            if ( layerId == lyr.Name ) {
                layer = lyr;
            }

        } );
        if ( layer == null ) {
            layer = self.createGraphicLayerWithId( layerId, layerId );

        }
        source = layer.getSource();
        var feature = source.getFeatureById( id );
        if ( !feature ) {
            let geofenceFeature = this.wktFormat.readFeature( geometryString );
            var geometry = geofenceFeature.getGeometry().transform( "EPSG:4326", "EPSG:3857" );
            geofenceFeature.setGeometry( geometry );
            geofenceFeature.setId( id );
            source.addFeature( geofenceFeature );
            source.refresh();

        }
    }

    public zoomToFeature( _feature, color, width ) {
        if ( this.selectedfeature ) {
            this.selectedfeature.setStyle( [ new ol.style.Style( {
                stroke: new ol.style.Stroke( ( {
                    color: "#198cff ",
                    width: 1
                } ) ),
                zIndex: 100
            } ) ] );

        }
        var extent = _feature.getGeometry().getExtent();
        this.SetCenterOfExtent( extent );
        var size: any = this.map.getSize();
        this.map.getView().fit( extent, size );
        _feature.setStyle( [ new ol.style.Style( {
            stroke: new ol.style.Stroke( ( {
                color: color,
                width: width
            } ) ),
            zIndex: 100
        } ) ] );
        this.selectedfeature = _feature;

    }

    public ZoomToMultiFeatures( _feature, color, width ) {
        var extent = _feature.getGeometry().getExtent();
        this.SetCenterOfExtent( extent );
        var size: any = this.map.getSize();
        this.map.getView().fit( extent, size );
        _feature.setStyle( [ new ol.style.Style( {
            stroke: new ol.style.Stroke( ( {
                color: color,
                width: width
            } ) ),
            zIndex: 100
        } ) ] );
        this.selectedfeature = _feature;

    }

    public ModifyDraw( _feature ) {

        var feature = this.drawingGraphicSource.getFeatureById( _feature.Id );
        if ( feature ) {


            let modifyControl = new ol.interaction.Modify( {
                features: feature,
                source: this.drawingGraphicSource
                //  type: Interaction
            } );
            this.map.getInteractions().extend( [ modifyControl ] );
            modifyControl.setActive( true );
            var self = this;
            modifyControl.on( "modifyend", function ( e ) {
                var geometryMeasure = 0;

                var geometry = e.features.item( 0 ).getGeometry();

                geometryMeasure = geometry.getArea();

                var newObject = jQuery.extend( true, {}, geometry );

                var newObject = newObject.transform( "EPSG:3857", "EPSG:4326" );
                var wktGeometry = self.wktFormat.writeGeometry( newObject );
                self.EditDraw$.next( {
                    measure: geometryMeasure.toFixed( 3 ),
                    geometryObject: wktGeometry
                } );


            } );
        }
    }

    public GetDrawById( Id ) {

        return this.drawingGraphicSource.getFeatureById( Id )
    }

    public getPointExtent( geometryString ) {

        var geofenceFeature = this.wktFormat.readFeature( geometryString );
        var geometry = geofenceFeature.getGeometry().transform( "EPSG:4326", "EPSG:3857" );
        geofenceFeature.setGeometry( geometry );
        var extent = geofenceFeature.getGeometry().getExtent();
        return extent;
    }

    public MergeExtent( ExtentList ) {
        var finalExtent = extent.createEmpty();
        ExtentList.forEach( function ( ex ) {
            extent.extend( finalExtent, ex );
        } );
        // more than one
        if ( ExtentList.length > 1 ) {
            this.map.getView().fit( finalExtent, this.map.getView().getZoom() );
        }
        // only one
        else {
            var c = extent.getCenter( finalExtent );
            this.map.getView().setCenter( c );
            //var curern = this.map.getView().getZoom();
            //if (curern != 16)
            //    this.map.getView().setZoom(16);
        }

    }

    public CalculateRotate( Loc1, Loc2 ) {
        var angle = -Math.atan2( Math.sin( Loc1.Longitude - Loc2.Longitude ) * Math.cos( Loc2.Latitude ), Math.cos( Loc1.Latitude ) * Math.sin( Loc2.Latitude ) - Math.sin( Loc1.Latitude ) * Math.cos( Loc2.Latitude ) * Math.cos( Loc1.Latitude - Loc2.Latitude ) );
        return angle;
    }

    public CalculatefeatureRotate( id ) {
        var feature = this.vectorSource.getFeatureById( id );
        if ( feature )
            return feature.getStyle().getImage().getRotation();
        else
            return 0;

    }

    public ChangeMapSource( mapType, mapurl ) {
        this.mapUrl = mapurl;
        switch ( mapType ) {
            case "esri": {
                this.base_source = new ol.source.XYZ( {
                    url: this.mapUrl
                } );

                break;
            }
            case "google": {
                this.base_source = new ol.source.XYZ( {
                    url: this.mapUrl
                } );
                break;
            }
            default: {
                this.base_source = new ol.source.OSM();
                break;
            }


        }
        this.base_layer.setSource( this.base_source );
    }

    public ChangeFeatureName( id, text ) {
        var feature = this.vectorSource.getFeatureById( id );
        if ( feature ) {
            feature.getStyle().getText().setText( text );
            this.vectorSource.refresh();
        }
    }

    //#endregion

    //#region History
    public createGraphicLayerWithId( id: string, Name: string ): any {
        var graphicSource = new ol.source.Vector( {} );
        var graphicLayer: any = new ol.layer.Vector( {
            source: graphicSource
        } );
        graphicLayer.id = id;
        graphicLayer.Name = Name;
        this.map.addLayer( graphicLayer );
        return graphicLayer;
    }

    public clearLayerGraphics( layer ) {
        if ( layer ) {
            layer.getSource().clear();
        }
    }

    public removeOverLayById( Id ) {
        let overlays: any = this.map.getOverlays();
        var index = overlays.a.findIndex( p => p.id == Id );
        if ( index > -1 )
            this.map.removeOverlay( overlays.a[ index ] );
    }

    public addEventOverLayOnMap( lat, long, overlayElement, evenTypeId, eventId ) {
        var pos = proj.transform( [ lat, long ], 'EPSG:4326', 'EPSG:3857' );

        var overlay: any = new ol.Overlay( {
            position: pos,
            positioning: 'top-center',
            element: overlayElement

        } );
        overlay.setElement( overlayElement );
        overlay.id = eventId;
        overlay.evenTypeId = evenTypeId;

        if ( this.enableOverlayClick ) {
            overlayElement.addEventListener( 'click', function ( x ) {
                this.OverlayClicked$.next( {
                    'eventTypeId': evenTypeId,
                    'startDateTime': eventId
                } );
            }.bind( this ) );
        }

        this.map.addOverlay( overlay );

        return overlay;
    }

    public addFeatureOnMap( featureId, geometryString, source, featureColor, labelText: string = "", offsetY: number = 0, src: string = "" ) {

        var geofenceFeature = this.wktFormat.readFeature( geometryString );
        var geometry = geofenceFeature.getGeometry().transform( "EPSG:4326", "EPSG:3857" );
        geofenceFeature.setGeometry( geometry );
        geofenceFeature.setId( featureId );
        var type = geofenceFeature.getGeometry().getType();
        if ( type == 'Point' ) {

            var options: any = {
                text: labelText,
                textBaseline: 'bottom',
                font: '14px sans-serif',
                Weight: 'Bold',
                offsetY: offsetY,
                stroke: new ol.style.Stroke( {
                    color: '#FFE000',
                    width: 2
                } )
            };
            geofenceFeature.setStyle( new ol.style.Style( {
                image: new ol.style.Icon( ( {
                    color: featureColor,
                    crossOrigin: 'anonymous',
                    src: src == "" ? 'https://openlayers.org/en/v4.1.1/examples/data/dot.png' : src
                } ) ),
                text: new ol.style.Text( options )
            } ) );
        } else {

            geofenceFeature.setStyle( [ new ol.style.Style( {
                stroke: new ol.style.Stroke( ( {
                    color: featureColor,
                    width: 5
                } ) ),
                zIndex: 100
            } ) ] );
        }
        source.addFeature( geofenceFeature );
        source.refresh();
        return geofenceFeature;
    }

    public DeleteGraphicLayer( layer ) {
        this.map.removeLayer( layer );
    }

    public removeOverlay( overlay ) {

        if ( overlay )
            this.map.removeOverlay( overlay );
    }
    //#endregion

    //#region POPUP
    //public createFeaturePopups() {

    //    var element = this.PopupElement._popover._elementRef.nativeElement;

    //    this.popup = new ol.Overlay({
    //        element: element,
    //        positioning: 'bottom-center',
    //        stopEvent: false,
    //        offset: [0, 0]
    //    });
    //    this.map.addOverlay(this.popup);
    //}
    //#endregion

    //#region  Alatir Layers

    private addAltairLayers() {
        let poiLayer = this.createGraphicLayerWithId( "POI", "AltairPOI" );
        poiLayer.setVisible( false );
        let branchLayer = this.createGraphicLayerWithId( "Branch", "AltairPOI" );
        branchLayer.setVisible( false );
        let geofenceLayer = this.createGraphicLayerWithId( "Geofence", "AltairPOI" );
        geofenceLayer.setVisible( false );
    }

    private onCheckAltairLayer( layer ) {
        setTimeout( () => {
            let selectedLayer;
            this.map.getLayers().forEach( function ( lyr ) {
                if ( layer == lyr.id ) {
                    selectedLayer = lyr;
                }
            } );
            // In case it Hiden   ----> show and get data
            if ( !selectedLayer.getVisible() ) {
                let List = this.GetMapExtent();
                let minpoint = ol.proj.transform( [ List[ 0 ], List[ 1 ] ], 'EPSG:3857', 'EPSG:4326' );
                let maxpoint = ol.proj.transform( [ List[ 2 ], List[ 3 ] ], 'EPSG:3857', 'EPSG:4326' );
                let pointlist = [];
                pointlist.push( minpoint[ 0 ] );
                pointlist.push( minpoint[ 1 ] );
                pointlist.push( maxpoint[ 0 ] );
                pointlist.push( maxpoint[ 1 ] );
                if ( layer == "POI" ) {
                    this.poiLayerSelected = true;
                    this._altairLayerService.getPOI( pointlist ).subscribe( response => {
                        if ( response && response.ok ) {
                            var result = JSON.parse( response.text() );
                            if ( result && !result.IsErrorState ) {
                                result.Value.forEach( type => {
                                    this.AddFeaturewithLayer( "POI", type.Location.Latitude, type.Location.Longitude, type.ViewName, 'poi_' + type.Id, "/assets/img/map/POI.png" )
                                } );
                            }
                        }
                    } );

                } else if ( layer == "Branch" ) {
                    this.branchLayerSelected = true;
                    this._altairLayerService.getBranch( pointlist ).subscribe( response => {
                        if ( response && response.ok ) {
                            var result = JSON.parse( response.text() );
                            if ( result && !result.IsErrorState ) {
                                result.Value.forEach( type => {
                                    this.AddFeaturewithLayer( "Branch", type.Location.Latitude, type.Location.Longitude, type.Name, 'Branch_' + type.Id, "/assets/img/map/Branch.png" )
                                } );
                            }
                        }
                    } );

                } else if ( layer == "Geofence" ) {
                    this.geofenceLayerSelected = true;
                    this._altairLayerService.getGeofence( pointlist ).subscribe( response => {
                        if ( response && response.ok ) {
                            var result = JSON.parse( response.text() );
                            if ( result && !result.IsErrorState ) {
                                this.geofencesOnLayer = result.Value;

                                result.Value.forEach( type => {
                                    this.adddrawOnLayer( "Geofence", type.Id + 'g', type.GeofenceShape );
                                    // we 'g' char in to id because in live tracking when we are clicking on geofence, it consider this click on vehicle icon so it will make request to backend to right panel
                                    // with char 'g', we will check that this id belongs to geofence or vehicle
                                } );
                            }
                        }
                    } );

                }
                selectedLayer.setVisible( true );
            }
            // in case show --->  hide it 
            else {
                if ( layer == "POI" )
                    this.poiLayerSelected = false;
                else if ( layer == "Branch" )
                    this.branchLayerSelected = false;
                else if ( layer == "Geofence" )
                    this.geofenceLayerSelected = false;
                selectedLayer.setVisible( false );
            }
        }, 0 );
    }

    private changeAlatirLayerextend() {
        var self = this;
        let List = this.GetMapExtent();
        let minpoint = ol.proj.transform( [ List[ 0 ], List[ 1 ] ], 'EPSG:3857', 'EPSG:4326' );
        let maxpoint = ol.proj.transform( [ List[ 2 ], List[ 3 ] ], 'EPSG:3857', 'EPSG:4326' );

        let pointlist = [];
        pointlist.push( minpoint[ 0 ] );
        pointlist.push( minpoint[ 1 ] );
        pointlist.push( maxpoint[ 0 ] );
        pointlist.push( maxpoint[ 1 ] );
        this.map.getLayers().forEach( function ( lyr ) {
            if ( lyr.id == "POI" && self.poiLayerSelected ) {
                self._altairLayerService.getPOI( pointlist ).subscribe( response => {
                    if ( response && response.ok ) {
                        var result = JSON.parse( response.text() );
                        if ( result && !result.IsErrorState ) {
                            result.Value.forEach( type => {
                                self.AddFeaturewithLayer( "POI", type.Location.Latitude, type.Location.Longitude, type.ViewName, 'alatirlayerpoi_' + type.Id, "/assets/img/map/POI.png" )
                            } );
                        }
                    }
                } );

            } else if ( lyr.id == "Branch" && self.branchLayerSelected ) {
                self._altairLayerService.getBranch( pointlist ).subscribe( response => {
                    if ( response && response.ok ) {
                        var result = JSON.parse( response.text() );
                        if ( result && !result.IsErrorState ) {
                            result.Value.forEach( type => {
                                self.AddFeaturewithLayer( "Branch", type.Location.Latitude, type.Location.Longitude, type.Name, 'alatirlayerbranch_' + type.Id, "/assets/img/map/Branch.png" )
                            } );
                        }
                    }
                } );

            } else if ( lyr.id == "Geofence" && self.geofenceLayerSelected ) {
                self._altairLayerService.getGeofence( pointlist ).subscribe( response => {
                    if ( response && response.ok ) {
                        var result = JSON.parse( response.text() );
                        if ( result && !result.IsErrorState ) {
                            result.Value.forEach( type => {
                                if ( self.geofencesOnLayer.findIndex( c => c.Id == type.Id ) == -1 ) {
                                    self.geofencesOnLayer.push( type );
                                }

                                self.adddrawOnLayer( "Geofence", 'alatirlayergeofence_' + type.Id, type.GeofenceShape );
                            } );
                        }
                    }
                } );

            }
        } );
    }
    //#endregion

    private vehicleCodeClick() {
        //console.log( "vehicleCodeClick" );
        //console.log( "showVehicleCodeLabel" );
        //console.log( this.showVehicleCodeLabel );
        this.showVehicleCodeLabel = !this.showVehicleCodeLabel;
        //console.log( "showVehicleCodeLabel" );
        //console.log( this.showVehicleCodeLabel );
        this.toggleShowVehicleCodeLabel.emit( this.showVehicleCodeLabel )
    }
    private vehiclePlateNumberClick() {
        //console.log( "vehiclePlateNumberClick" );
        //console.log( "showVehiclePlateNumberLabel" );
        //console.log( this.showVehiclePlateNumberLabel );
        this.showVehiclePlateNumberLabel = !this.showVehiclePlateNumberLabel;
        //console.log( "showVehiclePlateNumberLabel" );
        //console.log( this.showVehiclePlateNumberLabel );
        this.toggleShowVehiclePlateNumberLabel.emit( this.showVehiclePlateNumberLabel )
    }
    private sensorsClick() {
        //console.log( "sensorsClick" );
        //console.log( "showSensors" );
        //console.log( this.showSensors );
        this.showSensors = !this.showSensors;
        //console.log( "showSensors" );
        //console.log( this.showSensors );
        this.toggleShowSensors.emit( this.showSensors )
    }

    /**
     *addMarker function to add featured layer of marker on map
     *coordinate : [] of mouce lat and long of mouce ckicks
     *mapId : to implement the marker on provided id map 
     */
    public addMarker( coordinate, mapId, transform = true ) {
        //console.log("coordinate", coordinate)
        if ( this.mapId == mapId ) {
            // coordinate must be transformed 
            var lonlat = transform ? ol.proj.transform( coordinate, 'EPSG:3857', 'EPSG:4326' ) : coordinate;
            //console.log("after transform", lonlat)
            /**
             * MarkertransformedLat & MarkertransformedLong: public propeties to be reached from 
             * out side component after transforing
             */
            this.MarkertransformedLat = lonlat[ 1 ];
            this.MarkertransformedLong = lonlat[ 0 ];
            this.AddormodifyFeature( this.MarkertransformedLat, this.MarkertransformedLong, "you are here", "marker", "/assets/img/map/location-icon.svg" );
        }
    }
    public removeMarker() {
        //console.log("removeMarker")
        this.RemoveFeature( "marker" );
    }

    // Search place which takes address text and returns lat and long 
    public searchPlace( addressText: string, city: string = "Egypt" ): any {
        let searchText = addressText ? addressText : "";
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode( {
            'address': searchText,
            'componentRestrictions': {
                country: city
            }
        }, ( results, status ) => {
            //if ( status == google.maps.GeocoderStatus.OK && results && results.length > 0 ) {
                //set latitude, longitude 
                // let place = results[0].geometry.location;
                //let obj={
                //    latitude: place.lat(),
                //    longitude: place.lng()
                //}

                // filter results
                console.log("results", results);

                // let newResults;

                // results.map( ( details, detailsIndex ) => {
                //     details.address_components.map( addressDetails => addressDetails.long_name == "Egypt" ? newResults = results[ detailsIndex ] : "" );
                // } );

                // let latAndLong = newResults.geometry.location;
                // // console.log("newResults", newResults);
                // let obj = {
                //     latitude: latAndLong.lat(),
                //     longitude: latAndLong.lng()
                // }
                // //console.log("obj", obj)
                 this.onLocationsDetected.emit( results );
            //}
        } );
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/mapComponent/map-Component.component.ts